import { render, staticRenderFns } from "./RfidIcon.vue?vue&type=template&id=bcc34f14&scoped=true&"
import script from "./RfidIcon.vue?vue&type=script&lang=js&"
export * from "./RfidIcon.vue?vue&type=script&lang=js&"
import style0 from "./RfidIcon.vue?vue&type=style&index=0&id=bcc34f14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc34f14",
  null
  
)

export default component.exports